import React from "react";

const FloatingUploadBtn = ({onClick}) => {
  return (
    <button 
      className="fixed bottom-[60px] left-[40px] flex border-none justify-center items-center bg-[#0068FF] w-[60px] h-[60px] rounded-[10px] transition duration-200 ease-in-out shadow-[0_4px_12px_rgba(0,0,0,0.15)]"
      onClick={onClick}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 18V10H0V8H8V0H10V8H18V10H10V18H8Z" fill="white" />
      </svg>
    </button>
  );
};

export default FloatingUploadBtn;
